import { render, staticRenderFns } from "./system_role_list.vue?vue&type=template&id=3be58a2c&scoped=true&"
import script from "./system_role_list.vue?vue&type=script&lang=js&"
export * from "./system_role_list.vue?vue&type=script&lang=js&"
import style0 from "./system_role_list.vue?vue&type=style&index=0&id=3be58a2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be58a2c",
  null
  
)

export default component.exports